<script lang="ts">
	import type { Tokens } from 'marked';

	interface Props {
		token: Tokens.HTML;
	}

	let { token }: Props = $props();
</script>

<!-- Untrusted Markdown: raw HTML is shown as text, never parsed. -->
<p class="break-words whitespace-pre-wrap">{token.text}</p>
